<page-banner
  [meta]="pageBannerMeta"
  [isNoteRestricted]="false"
  [disableAddNoteBtn]="false"
  (addNoteClick)="handleAddNote()"
>
  <div class="page-banner" top-left>
    <exit-view [exitState]="exitState" [icon]="'close-large-white'" id="close-button" isInverted="true"> </exit-view>
    <span class="title-message">Settings</span>
    <nv-icon [name]="'caret-right-white'"></nv-icon>
    <ng-container *ngIf="hasLoaded">
      <span class="title-message">
        {{ selectedLeftNavItem.name }}
      </span>
      <span *ngIf="selectedLeftNavItem?.tooltip"><nv-icon class="info-icon-alignment" name="info" [tooltipData]="selectedLeftNavItem.tooltip" nvTooltip></nv-icon></span>
    </ng-container>
  </div>
</page-banner>

<school-two-column-layout>
  <settings-left-nav></settings-left-nav>
</school-two-column-layout>


